import 'react-app-polyfill/ie11';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react'
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const store = configureStore();


i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: { translation: require('./locales/en.json') },
      ko: { translation: require('./locales/ko.json') },
      vi: { translation: require('./locales/vi.json') }
    },
    fallbackLng: 'ko',
    debug: true,
    interpolation: {
      escapeValue: false // not needed for React as it escapes by default
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'], // 감지 순서
      caches: ['localStorage', 'cookie'], // 한번 선택된 언어 기억
    }
  });

ReactDOM.render(<Provider store={store.store}>
  <PersistGate loading={null} persistor={store.persistor} >
    <App historyStore={store.store} />
  </PersistGate>
</Provider>, document.getElementById('root'));